import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Invoice} from './invoices';

@Injectable()
export class InvoiceService {

    constructor(private http: Http) {

    }

    getAll(page: number = 1, sort: string = '') {
        let currentfilter = JSON.parse(localStorage.getItem('filter'));
        if (!currentfilter) {
            currentfilter = {};
        }

        const params = new URLSearchParams();
        params.set('page', page + '');
        params.set('sorts', sort);
        for (let key in currentfilter) {
            if (currentfilter[key]) {
                params.set('filter[' + key + ']', currentfilter[key])
            }
        }
        return this.http.get('invoices?' + params.toString()).map((response: Response) => response.json());
    }
    deletePic(_id: string) {
        return this.http.put('org/picture/delete/' + _id,{}).map((response: Response) => response.json());
    }
    deletePic1(_id: string) {
        return this.http.put('org/picture/delete1/' + _id,{}).map((response: Response) => response.json());
    }
    sendByEmail(_id:string, email:string, lang:string) {
        return this.http.post('invoices/send/' + _id,{'email':email, 'lang':lang}).map((response: Response) => response.json());
    }
    getAllCurrencies() {
        return this.http.get('all/currencies').map((response: Response) => response.json());
    }
    getLogo() {
        return this.http.get('invoices/logo').map((response: Response) => response.json());
    }

    getById(_id: string) {
        return this.http.get('invoices/' + _id).map((response: Response) => response.json());
    }


    getTrashedById(_id: string) {
        return this.http.get('invoices/trashed/' + _id).map((response: Response) => response.json());
    }

    restoreTrashedById(_id: string) {
        return this.http.put('invoices/trashed/' + _id, {}).map((response: Response) => response.json());
    }

    create(invoice: Invoice) {
        return this.http.post('invoices', invoice).map((response: Response) => response.json());
    }

    update(invoice: Invoice) {
        return this.http.put('invoices/' + invoice.id, invoice).map((response: Response) => response.json());
    }

    delete(_id: string) {
        return this.http.delete('invoices/' + _id).map((response: Response) => response.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/views/pos/invoices/invoices.service.ts